export function clamp(n, min, max) {
  return Math.max(min, Math.min(max, n));
}

export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(email.trim());
}

export function pad2(n) {
  return String(n).padStart(2, "0");
}

export function buildDobISO({ year, month, day }) {
  if (!year || !month || !day) return "";
  return `${year}-${pad2(month)}-${pad2(day)}`;
}

export function buildTime12({ hour, minute, meridiem }) {
  if (!hour || minute === "" || !meridiem) return "";
  return `${pad2(hour)}:${pad2(minute)} ${meridiem}`;
}

export function buildTime24({ hour, minute, meridiem }) {
  if (!hour || minute === "" || !meridiem) return "";
  let hour24 = parseInt(hour, 10);
  if (meridiem === "PM" && hour24 !== 12) {
    hour24 += 12;
  } else if (meridiem === "AM" && hour24 === 12) {
    hour24 = 0;
  }
  return `${pad2(hour24)}:${pad2(minute)}`;
}
